import { Respuesta } from './Respuesta';
import { Grupo } from './grupo';

export class GrupoResult {

    public miRespuesta: Respuesta = new Respuesta();
    public miListGrupo: Grupo[] = [];

}
